import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import English from "../../assets/Reading.svg";
import Math from "../../assets/MathmaticalReasoning.svg";
import ThinkingSkill from "../../assets/ThinkingSkills.svg";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function TestAssesmentBooks() {
  const [assessmentDetails, setAssessmentDetails] = useState({});
  const [showPopup, setShowPopup] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const handleButtonClick = () => {
    setShowPopup(true);
  };

  const handleCancel = () => {
    setShowPopup(false);
  };

  const handleConfirm = () => {
    setShowPopup(false);
    SubmitResult();
  };

  const navigate = useNavigate();

  useEffect(() => {
    const fetchAssessmentDetails = async () => {
      try {
        const email = localStorage.getItem("userEmail");
        if (!email) {
          toast.error("No email found in localStorage.");
          return;
        }
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/freeassesment/userAssessmentDetails?email=${email}`
        );
        setAssessmentDetails(response.data);
      } catch (error) {
        toast.error(
          error.response?.data?.message || "Failed to fetch assessment details."
        );
      }
    };

    fetchAssessmentDetails();
  }, []);

  const SubmitResult = async () => {
    setIsLoading(true);
    try {
      const email = localStorage.getItem("userEmail");
      const examType = localStorage.getItem("examType");

      if (!email) {
        toast.error("No email found in localStorage.");
        return;
      }
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/freeassesment/send-user-details`,
        { email, examType }
      );

      toast.info(response.data.message);

      localStorage.removeItem("userEmail");
      navigate("/email-confirmation");
    } catch (error) {
      toast.error(
        error.response?.data?.message || "An error occurred. Please try again."
      );
    } finally {
      setIsLoading(false);
    }
  };

  const handleCheckQuestions = async (path, type) => {
    try {
      const email = localStorage.getItem("userEmail");
      if (!email) {
        toast.error("No email found in localStorage.");
        return;
      }

      const endpoints = {
        reading: "/api/freeassesment/checkReadingTestAlreadyConduct",
        math: "/api/freeassesment/checkMathTestAlreadyConduct",
        thinking: "/api/freeassesment/checkThinkingSkillsTestAlreadyConduct"
      };

      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}${endpoints[type]}`,
        { email }
      );

      if (response.data.navigate) {
        navigate(path);
      } else {
        toast.warning(
          response.data.message || "This test is already completed."
        );
      }
    } catch (error) {
      toast.error(
        error.response?.data?.message || "An error occurred. Please try again."
      );
    }
  };

  const reading_test = assessmentDetails.user?.reading_score;
  const math_test = assessmentDetails.user?.maths_score;
  const thinking_skill = assessmentDetails.user?.thinking_skills_score;

  // Determine button states
  const isMathEnabled = math_test === null;
  const isThinkingEnabled = math_test !== null && thinking_skill === null;
  const isReadingEnabled = thinking_skill !== null && reading_test === null;


  return (
    <div className="pb-10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 mt-4 sm:mt-10 space-y-4 sm:space-y-8">
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-5 bg-white border border-gray-300 rounded-xl overflow-hidden hover:bg-gray-50 transition-all sm:hover:-translate-y-1 sm:hover:shadow-md">
          <div className="w-full sm:w-1/3 h-48 sm:h-56 flex-shrink-0">
            <img
              className="w-full h-full object-cover object-center"
              loading="lazy"
              src={Math}
              alt="Math"
            />
          </div>

          <div className="w-full flex flex-col gap-1 p-4 sm:p-0 sm:py-2 sm:mt-6">
            <p className="text-lg sm:text-xl md:text-2xl font-bold">Mathematical Reasoning</p>
            {/* <p className="text-sm sm:text-base text-gray-800 font-semibold">
              Enhance your problem-solving and numerical skills
            </p> */}
            <p className="text-gray-800 font-semibold text-sm sm:text-base">
              <strong className="text-black font-bold text-base sm:text-lg">Questions:</strong> 10
            </p>
            <span className="text-gray-800 font-semibold text-sm sm:text-base">
              <strong className="text-black font-bold text-base sm:text-lg">Time:</strong> 12 minutes
            </span>
            <div className="flex items-center justify-end mt-2 sm:mt-0">
              <button
                onClick={() => handleCheckQuestions("/questions-page/randomMathsQuestions", "math")}
                disabled={!isMathEnabled}
                className={`w-28 sm:w-32 h-9 sm:h-10 px-3 sm:px-4 mr-2 sm:mr-3 mb-2 text-white font-bold rounded-lg ${isMathEnabled
                    ? "bg-gradient-to-r from-orange-500 to-yellow-400 hover:from-orange-600 hover:to-yellow-500"
                    : "bg-gray-400 cursor-not-allowed"
                  } focus:outline-none text-sm sm:text-base transition-transform ${isMathEnabled ? "hover:translate-x-[5px]" : ""
                  }`}
              >
                {math_test !== null ? "Completed" : "Start Test"}
              </button>
            </div>
          </div>
        </div>

        {/* Thinking Skills Card */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-5 bg-white border border-gray-300 rounded-xl overflow-hidden hover:bg-gray-50 transition-all sm:hover:-translate-y-1 sm:hover:shadow-md">
          <div className="w-full sm:w-1/3 h-48 sm:h-56 flex-shrink-0">
            <img
              className="w-full h-full object-cover object-center"
              loading="lazy"
              src={ThinkingSkill}
              alt="ThinkingSkill"
            />
          </div>

          <div className="w-full flex flex-col gap-1 p-4 sm:p-0 sm:py-2 sm:mt-6">
            <p className="text-lg sm:text-xl md:text-2xl font-bold">Thinking Skills</p>
            {/* <p className="text-sm sm:text-base text-gray-800 font-semibold">
              Test your logical and analytical thinking abilities.
            </p> */}
            <p className="text-gray-800 font-semibold text-sm sm:text-base">
              <strong className="text-black font-bold text-base sm:text-lg">Questions:</strong> 10
            </p>
            <span className="text-gray-800 font-semibold text-sm sm:text-base">
              <strong className="text-black font-bold text-base sm:text-lg">Time:</strong> 10 minutes
            </span>
            <div className="flex items-center justify-end mt-2 sm:mt-0">
              <button
                onClick={() => handleCheckQuestions("/questions-page/randomThinkingskillQuestions", "thinking")}
                disabled={!isThinkingEnabled}
                className={`w-28 sm:w-32 h-9 sm:h-10 px-3 sm:px-4 mr-2 sm:mr-3 mb-2 text-white font-bold rounded-lg ${isThinkingEnabled
                    ? "bg-gradient-to-r from-orange-500 to-yellow-400 hover:from-orange-600 hover:to-yellow-500"
                    : "bg-gray-400 cursor-not-allowed"
                  } focus:outline-none text-sm sm:text-base transition-transform ${isThinkingEnabled ? "hover:translate-x-[5px]" : ""
                  }`}
              >
                {thinking_skill !== null ? "Completed" : "Start Test"}
              </button>
            </div>
          </div>
        </div>
        {/* Reading Test Card */}
        <div className="flex flex-col sm:flex-row gap-3 sm:gap-5 bg-white border border-gray-300 rounded-xl overflow-hidden hover:bg-gray-50 transition-all sm:hover:-translate-y-1 sm:hover:shadow-md">
          <div className="w-full sm:w-1/3 h-48 sm:h-56 flex-shrink-0">
            <img
              className="w-full h-full object-cover object-center"
              loading="lazy"
              src={English}
              alt="English"
            />
          </div>

          <div className="w-full flex flex-col gap-1 p-4 sm:p-0 sm:py-2 sm:mt-6">
            <p className="text-lg sm:text-xl md:text-2xl font-bold">Reading</p>
            {/* <p className="text-sm sm:text-base text-gray-800 font-semibold">
              Boost your comprehension and analytical reading abilities.
            </p> */}
            <p className="text-gray-800 font-semibold text-sm sm:text-base">
              <strong className="text-black font-bold text-base sm:text-lg">Questions:</strong> 10
            </p>
            <span className="text-gray-800 font-semibold text-sm sm:text-base">
              <strong className="text-black font-bold text-base sm:text-lg">Time:</strong> 12 minutes
            </span>
            <div className="flex items-center justify-end mt-2 sm:mt-0">
              <button
                onClick={() => handleCheckQuestions("/questions-page/randomReadingQuestions", "reading")}
                disabled={!isReadingEnabled}
                className={`w-28 sm:w-32 h-9 sm:h-10 px-3 sm:px-4 mr-2 sm:mr-3 mb-2 text-white font-bold rounded-lg ${isReadingEnabled
                    ? "bg-gradient-to-r from-orange-500 to-yellow-400 hover:from-orange-600 hover:to-yellow-500"
                    : "bg-gray-400 cursor-not-allowed"
                  } focus:outline-none text-sm sm:text-base transition-transform ${isReadingEnabled ? "hover:translate-x-[5px]" : ""
                  }`}
              >
                {reading_test !== null ? "Completed" : "Start Test"}
              </button>
            </div>
          </div>
        </div>

      </div>

      {/* Submit Button */}
      <div className="max-w-2xl mx-auto my-6 px-4 sm:px-0">
        <button
          onClick={handleButtonClick}
          className="w-full sm:w-auto flex mx-auto text-white font-bold py-2 px-6 sm:px-10 rounded-md bg-gradient-to-r from-orange-500 to-yellow-500 hover:from-orange-600 hover:to-yellow-600 focus:outline-none shadow hover:shadow-lg transition-transform transform hover:scale-105 text-sm sm:text-base"
        >
          Submit
        </button>
      </div>

      {/* Popup Modal */}
      {showPopup && (
        <div className="fixed z-50 inset-0 flex items-center justify-center bg-black bg-opacity-50 p-4">
          <div
            className="bg-white rounded-lg shadow-lg w-full max-w-md"
            role="dialog"
            aria-modal="true"
            aria-labelledby="modal-headline"
          >
            <div className="relative p-4 sm:p-6">
              <button
                onClick={handleCancel}
                type="button"
                aria-label="Close"
                className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 focus:outline-none"
              >
                <svg
                  className="h-6 w-6"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="2"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
              <div className="flex flex-col items-center">
                <div className="flex items-center justify-center h-12 w-12 rounded-full bg-green-100">
                  <svg
                    className="h-6 w-6 text-green-500"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M5 13l4 4L19 7"
                    />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mt-4" id="modal-headline">
                  Confirm Submission
                </h3>
                <p className="text-sm text-gray-600 mt-2 text-center">
                  Are you sure you want to submit your results? This action
                  cannot be undone.
                </p>
              </div>
              <div className="flex items-center justify-end mt-6 space-x-3">
                <button
                  onClick={handleCancel}
                  type="button"
                  className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 focus:outline-none"
                >
                  No
                </button>
                <button
                  onClick={handleConfirm}
                  type="button"
                  className="px-4 py-2 text-sm font-medium text-white bg-gradient-to-r from-blue-500 to-blue-600 rounded-lg hover:from-blue-600 hover:to-blue-700 focus:outline-none"
                >
                  Yes, Confirm
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Loading Spinner */}
      {isLoading && (
        <div className="fixed inset-0 flex justify-center items-center bg-gray-500 bg-opacity-50 z-50">
          <div className="animate-spin rounded-full h-12 w-12 border-t-4 border-blue-500"></div>
          <span className="ml-3 text-white text-sm sm:text-base">
            Sending Result on email address...
          </span>
        </div>
      )}

      <ToastContainer />
    </div>
  );
}

export default TestAssesmentBooks;